// @flow
import uuid from 'uuid/v4'

/**
 * Utility errors
 * @module util/errors
 */

/**
 * A wrapper for errors returned from a network request
 * @type {Error}
 * @param {string} url - URL that returned the error
 * @param {string|Object} requestBody - Any body data sent with the request
 * @param {number} statusCode - Status code of error
 * @param {string} message - Any text sent with response
 * @param {*} originalCall - Any data around the call that caused the error
 * @property {*} originalCall - Any data around the call that caused the error
 * @property {string} url - URL that returned the error
 * @property {string|Object} body - Any body data sent with the request
 * @property {number} statusCode - Status code of error
 * @property {string} message - Any text sent with response
 * @property {*} originalCall - Any data around the call that caused the error
 */
export function NetworkResponseError(
  url: string,
  requestBody: ?Object,
  statusCode: ?number,
  message: string,
  originalCall: Object,
  ...extra: Array<mixed>
) {
  this.id = uuid()
  this.name = 'NetworkResponseError'
  this.message = message || ''
  this.statusCode = statusCode
  this.url = url
  this.body = requestBody
  this.originalCall = originalCall
  this.extra = extra
}
NetworkResponseError.prototype = Object.create(Error.prototype)
NetworkResponseError.prototype.constructor = NetworkResponseError
